import request from '@/utils/request'


// 获取用户详细信息
export function getHomePageInfo() {
  return request({
    url: '/api/home/getHomePageInfo',
    method: 'post',
  })
}

export function getWebsiteMenus() {
  return request({
    url: '/api/home/getWebsiteMenus',
    method: 'post'
  })
}


export function getWebsiteCompanyNewsBanner() {
  return request({
    url: '/api/home/getWebsiteCompanyNewsBanner',
    method: 'post',
  })
}
export function getWebsiteCompanyNewsList(query) {
  return request({
    url: '/api/home/getWebsiteCompanyNewsList',
    method: 'post',
	params: query
  })
}

export function getWebsiteCompanyNewsById(id) {
  return request({
    url: '/api/home/getWebsiteCompanyNewsById/' + id,
    method: 'post',
  })
}



export function getWebsiteCompanyPolicyBanner() {
  return request({
    url: '/api/home/getWebsiteCompanyPolicyBanner',
    method: 'post',
  })
}
export function getWebsiteCompanyPolicyList(query) {
  return request({
    url: '/api/home/getWebsiteCompanyPolicyList',
    method: 'post',
	params: query
  })
}

export function getWebsiteCompanyPolicyById(id) {
  return request({
    url: '/api/home/getWebsiteCompanyPolicyById/' + id,
    method: 'post',
  })
}

